'use client';
import {
    motion,
    type Transition,
    type UseInViewOptions,
    useInView,
    type Variant,
} from 'motion/react';
import { type ReactNode, useRef } from 'react';

interface InViewProps {
    children: ReactNode;
    variants?: {
        hidden: Variant;
        visible: Variant;
    };
    transition?: Transition;
    viewOptions?: UseInViewOptions;
    as?: React.ElementType;
}

const defaultVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
};

export function InView({
    children,
    variants = defaultVariants,
    transition,
    viewOptions,
    as = 'div',
}: InViewProps) {
    const ref = useRef(null);
    const isInView = useInView(ref, viewOptions);

    const MotionComponent = motion[as as keyof typeof motion] as typeof as;

    return (
        <MotionComponent
            ref={ref}
            initial='hidden'
            animate={isInView ? 'visible' : 'hidden'}
            variants={variants}
            transition={transition}>
            {children}
        </MotionComponent>
    );
}
